import {useContext} from "react"
import { UpdateClientContext } from "./context"

export function useUpdateClientHook() {
    return useContext(UpdateClientContext);
}